import * as React from "react";
import { Tooltip } from "antd";
import { EMail, getMailStr } from "utils/enum/orderListFormEnum";

// 确认函
export default containerBody => {
  const getContainer = () => {
    if (containerBody) {
      return document.querySelector(containerBody) || document.body;
    } else {
      return document.body;
    }
  };
  return {
    render: (text, record) => {
      let className: string = "";
      switch (text.toString()) {
        case EMail.no:
          className = "action-chahao";
          break;
        case EMail.yes:
          className = "action-gouhao";
          break;
        default:
          return "-";
      }
      return (
        <Tooltip
          placement="top"
          title={getMailStr(text)}
          getTooltipContainer={getContainer}
        >
          <i className={"action-user " + className} />
        </Tooltip>
      );
    }
  };
};
